import { Collection } from './collection'

export class Project {
 format = '';
 collections: Collection[] = [];
}
